

// actions types
export const GET_FOOTER_CATEGORIES = "GET_FOOTER_CATEGORIES";
export const FOOTER_CATEGORIES_LOADED = "FOOTER_CATEGORIES_LOADED";
export const GET_STATIC_PAGES = "GET_STATIC_PAGES";
export const STATIC_PAGES_LOADED = "STATIC_PAGES_LOADED";
export const GET_SOCIALS = "GET_SOCIALS";
export const SOCIALS_LOADED = "SOCIALS_LOADED";
export const GET_SITE_THEME = "GET_SITE_THEME";
export const SITE_THEME_LOADED = "FooterSITE_THEME_LOADED";
